import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { useSelector } from 'react-redux'

import { useArtboardMode, useProjectAccess } from '@/hooks'
import { PUBLISH_PERMISSION } from '@/permissions/project/definitions'

export const useShareAndPublish = () => {
  const isReadOnly = useSelector(
    migrationProjectSelector.getProjectLegacyAccessTypeIsReadOnly
  )

  const isTemplate = useSelector(migrationProjectSelector.getProjectIsTemplate)
  const { seoMode } = useArtboardMode()

  const id = useSelector(migrationProjectSelector.getProjectId)

  const trial = useSelector(migrationProjectSelector.getProjectIsTrial)

  const { hasAccess } = useProjectAccess(PUBLISH_PERMISSION.VIEW)

  const showShare = id && !trial && !isReadOnly && !seoMode
  const showPublish = hasAccess && !isTemplate && !isReadOnly && !seoMode

  return {
    showShare,
    showPublish,
  }
}
